import m from "./index.es106.js";
import "./index.es133.js";
import "react";
import "react-dom";
import "./index.es33.js";
import "./index.es134.js";
import { TimeZoneDate as a } from "./index.es506.js";

var s = function s(t) {
  return Intl.DateTimeFormat(m.language, {
    month: "short"
  }).format(t);
},
    p = function p(t) {
  return t.getFullYear().toString();
},
    w = {
  months: s,
  years: p
},
    r = function r() {
  return Array(3).fill(null).map(function () {
    return Array(4).fill(null);
  });
},
    M = r().map(function (t, e) {
  return {
    key: e,
    rows: t.map(function (l, o) {
      return new Date(new a().setFullYear(new a().getFullYear(), e * t.length + o, 1));
    })
  };
}),
    g = new a(),
    f = function f(t) {
  return r().map(function (e, l) {
    return {
      key: l,
      rows: e.map(function (o, n) {
        return new Date(new a().setFullYear(new a().getFullYear() - (l * e.length + n) + Math.ceil((t.getFullYear() - g.getFullYear()) / 12) * 12));
      })
    };
  });
},
    D = {
  months: function months(t, e) {
    return t.getMonth() === e.getMonth();
  },
  years: function years(t, e) {
    return t.getFullYear() === e.getFullYear();
  }
};

export { D as compareMap, M as months, w as showTextMap, f as years };